<template>
  <div id="leaseTransact">
    <div v-show="!childShow">
      <table-title>起租办理基本信息</table-title>
      <Form class="from" ref="formValidates" :model="formValidate" :label-width="125" inline :rules="ruleValidate">
        <!-- <FormItem label="租借人：" prop="leaseeId">
                    <leasee-select roleType="LEASEE" @onChange="onChangeLeasee" v-model="formValidate.leaseeId" />
                </FormItem>-->
        <FormItem label="标的物小类：" prop="targetType">
          <target-type-select v-model="formValidate.targetType" @on-change="onTargetType" />
        </FormItem>
        <FormItem label="框架协议号：" prop="agreementNo">
          <Select v-model="formValidate.agreementNo" style="width:200px" filterable clearable label-in-value @on-change="changeAgreementNO">
            <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <Button type="success" @click="goDetail" :disabled="formValidate.agreementNo?false:true" size="small">查看协议详情</Button>
        <br />

        <FormItem v-if="rentTermShow" label="约定期限：" prop="rentTerm">
          <InputNumber :min="1" style="width:200px" :disabled="rentDisable" v-model="formValidate.rentTerm" />
        </FormItem>
        <FormItem label="订单数量：" prop="orderAmount">
          <InputNumber :min="1" v-model="formValidate.orderAmount" style="width:200px" />
        </FormItem>
        <br />
        <FormItem label="预期交付时间：" prop="expectedDeliveryDate">
          <DatePicker type="date" placeholder="请选择预期交付时间" :editable="false" @on-change="expectDate" v-model="formValidate.expectedDeliveryDate" style="width:200px"></DatePicker>
        </FormItem>
        <FormItem label="是否清洗：" prop="cleaningRequired">
          <dict-select id="bitYesNo" @on-change="onChangeCode" :exclusion="[]" v-model="formValidate.cleaningRequired" />
          <el-alert type="warning" style="margin-top:5px" :closable="false" title="提示：清洗需要额外付费" show-icon />
        </FormItem>
        <br />
        <FormItem label="交付方式：" prop="deliveryMethod">
          <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="order.DeliveryMethod" :exclusion="[]" @on-change="onOrderMethod" v-model="formValidate.deliveryMethod" />
        </FormItem>
        <FormItem label="最大租赁额度">
          <InputNumber style="width:200px" disabled v-model="maxAmount" />
        </FormItem>
        <br />
        <FormItem label="责任分区" v-if="formValidate.leaseeId" prop="groupFlag" key="groupFlag">
          <bizSelect v-model="formValidate.groupFlag" url="http://CORE-MEMBER/messageService/respZoneService/queryRespZoneByMemberId" :params="{memberId:formValidate.leaseeId}" codeField="respZoneId" style="width:200px" />
        </FormItem>
        <br />
        <FormItem label="备注：" prop="leaseOrderComment" key="leaseOrderComment">
          <Input v-model="formValidate.leaseOrderComment" type="textarea" style="width:540px" />
        </FormItem><br>
        <FormItem label="上传附件">
          <upload ref="upFile" :height="70" :width="540" @success="uploadSuccess" @delete="onDelete"></upload>
        </FormItem>
        <template v-if="formValidate.deliveryMethod === 'DOORSTEP'">
          <Divider orientation="left">收货地址</Divider>
          <FormItem label="所在区域：" prop="receiveArea">
            <addr-cascader @on-select-change="onSelect" v-model="formValidate.receiveArea" />
          </FormItem>
          <Button type="success" @click="queryArea" :disabled="formValidate.leaseeId?false:true" size="small">选择地址</Button>
          <br />
          <FormItem label="详细地址：" prop="receiveAddress">
            <Input v-model="formValidate.receiveAddress" maxlength="100" show-word-limit type="textarea" style="width: 200px" />
            <recognize-region :address="formValidate.receiveAddress" @onRecognize="onRecognize" />
          </FormItem>
          <br />
        </template>
        <template v-if="formValidate.leaseeId">
          <Divider orientation="left">联系人信息</Divider>
          <Button type="success" style="margin:0 0 10px 39px" @click="addLinkMan">选择联系人</Button>
          <br />
          <FormItem label="联系人姓名">
            <Input v-model="linkVal.name" disabled style="width: 200px" />
          </FormItem>
          <FormItem label="手机号">
            <Input v-model="linkVal.mobile" disabled style="width: 200px" />
          </FormItem>
          <br />
          <FormItem label="邮箱">
            <Input v-model="linkVal.email" disabled style="width: 200px" />
          </FormItem>
          <FormItem label="证件号">
            <Input v-model="linkVal.identityNo" disabled style="width: 200px" />
          </FormItem>
          <br />
        </template>
      </Form>
      <div class="btn">
        <Button type="info" v-if="isBack" @click="goBack" style="margin-right: 10px">返回</Button>
        <Button type="warning" @click="reset()" style="margin-right: 10px">重置</Button>
        <Button type="success" @click="submit()">新增租赁订单</Button>
      </div>
      <contact-select ref="contactSelect" @on-select-contact="onSelectContact"></contact-select>
      <query-area ref="queryAreaRef" @onRow="onRow"></query-area>

    </div>
    <div v-if="childShow">
      <component v-bind:is="currentChild" :paramsData="currentParams" @onFinish="onFinish"></component>
    </div>
  </div>
</template>

<script>
import tableTitle from "@/components/tableTitle/tableTitle";
import addrCascader from "@/components/select/addr-cascader.vue";
import leaseeSelect from "@/components/select/payee-select.vue";
import dictSelect from "@/components/select/dict-select.vue";
import targetTypeSelect from "_c/select/targetTypeSelect";
import contactSelect from "@/components/select/contact-select.vue";
import queryArea from "./compoent/queryArea.vue";
import upload from "_c/upload/upload.vue";
import bizSelect from "_c/select/biz-select";

import frameworkAgreeDetail from "_v/user-center/lease/leaseList/frameworkAgreeDetail";

export default {
  name: "leaseTransact",
  components: {
    tableTitle,
    addrCascader,
    leaseeSelect,
    dictSelect,
    targetTypeSelect,
    contactSelect,
    frameworkAgreeDetail,
    queryArea,
    upload,
    bizSelect
  },
  data() {
    return {
      isBack: false,
      childShow: false,
      currentChild: "",
      currentParams: "",
      cityList: [],
      targetList: [],
      rentTermShow: true,
      rentDisable: true, //约定租期是否可输入
      attachmentFileIds: [], //附件
      formValidate: {
        number: "",
        leaseeId: "", //租借人ID
        targetType: "", //标的小类
        cleaningRequired: "0", //是否清洗
        receiveAddress: "",
        receiveArea: "", //所在区域
        receiveContactId: "", //联系人id,
        agreementNo: "", //框架协议号
        orderAmount: null, //订单数量
        expectedDeliveryDate: "", //预期交付时间
        deliveryMethod: "", //交付方式
        rentTerm: null, //约定租期
        leaseOrderComment: "",
        groupFlag: "" //责任分区
      },
      // options: {
      //     disabledDate(date) {
      //         return date && date.valueOf() < Date.now();
      //     }
      // },
      maxAmount: null, //最大租赁额度
      linkVal: {
        name: "",
        mobile: "",
        email: "",
        identityNo: ""
      },
      ruleValidate: {
        leaseeId: [{ required: true, message: "租借人不能为空！" }],
        targetType: [{ required: true, message: "请选择标的物小类" }],
        cleaningRequired: [
          { required: true, message: "请选择是否清洗！", trigger: "change" }
        ],
        agreementNo: [
          { required: true, message: "请选择框架协议号！", trigger: "change" }
        ],
        expectedDeliveryDate: [
          { required: true, message: "请选择预期交付时间", trigger: "change" }
        ],
        orderAmount: [{ required: true, message: "订单数量不能为空！" }],
        deliveryMethod: [
          { required: true, message: "请选择交付方式", trigger: "change" }
        ],
        cleaningRequired: [
          { required: true, message: "请选择是否清洗", trigger: "change" }
        ],
        rentTerm: [{ required: true, message: "约定租期不能为空" }],
        receiveAddress: [{ required: true, message: "详细地址不能为空" }],
        receiveArea: [
          { required: true, message: "请选择所在区域", trigger: "change" }
        ]
      }
    };
  },
  watch: {
    $route() {
      this.reset();
    }
  },
  activated() {
    this.getMoreOrder();
  },
  async mounted() {
    this.formValidate.leaseeId = sessionStorage.getItem("memberId");
    this.getMoreOrder();
  },
  methods: {
    // 获取再来一单数据
    getMoreOrder() {
      let dataRow = this.$route.query?.data
        ? JSON.parse(this.$route.query.data)
        : {};
      if (dataRow?.targetType) {
        this.$nextTick(async () => {
          this.isBack = true;
          this.formValidate.targetType = dataRow.targetType;
          this.formValidate.orderAmount = dataRow.orderAmount;
          this.formValidate.leaseOrderComment = dataRow.leaseOrderComment;
          this.formValidate.groupFlag = dataRow.groupFlag;
          this.formValidate.deliveryMethod = dataRow.deliveryMethod;
          this.formValidate.receiveAddress = dataRow.receiveAddress;
          this.formValidate.receiveArea = dataRow.receiveArea;
          this.formValidate.receiveContactId = dataRow.receiveContactId;
          this.linkVal.name = dataRow.receiveContactName;
          this.linkVal.mobile = dataRow.receiveContactMobile;
          this.linkVal.email = dataRow.receiveContactEmail;
          this.linkVal.identityNo = dataRow.receiveContactIdentityNo;
          this.formValidate.agreementNo = dataRow.agreementNo;
          await this.onTargetType(this.formValidate.targetType);
          this.checkAgreeMentNo();
          this.formValidate.rentTerm = dataRow.rentTerm
            ? dataRow.rentTerm
            : null;
        });
      } else {
        this.reset();
      }
    },
    // 上传成功
    uploadSuccess(params) {
      this.attachmentFileIds.push(params.body);
    },
    // 附件删除
    onDelete({ id }) {
      this.attachmentFileIds = this.attachmentFileIds.filter(
        item => item != id
      );
    },
    // 识别省市区
    onRecognize({ regionCode, address }) {
      this.formValidate.receiveArea = regionCode;
      this.formValidate.receiveAddress = address;
    },
    // 选择地址
    queryArea() {
      if (this.formValidate.leaseeId) {
        this.$refs["queryAreaRef"].openModal(this.formValidate.leaseeId);
      }
    },
    onRow(params) {
      this.formValidate.receiveArea = params.areaId;
      this.formValidate.receiveAddress = params.address;
      this.linkVal.name = params.contactName;
      this.linkVal.mobile = params.contactMobile;
      this.linkVal.email = params.contactEmail;
      this.linkVal.identityNo = params.contactIdentityNo;
      this.formValidate.receiveContactId = params.defaultContactId;
    },
    // 租借人
    // async onChangeLeasee(val) {
    //   this.formValidate.leaseeId = val;
    //   if (this.formValidate.leaseeId && this.formValidate.targetType) {
    //     await this.agreementList();
    //     // this.formValidate.agreementNo = "";
    //   }
    // },
    // 框架协议号
    changeAgreementNO(val) {
      if (val) {
        this.formValidate.agreementNo = val.value;
        this.checkAgreeMentNo();
      }
    },
    checkAgreeMentNo() {
      this.formValidate.rentTerm = null;
      let modelId = "";
      this.cityList.forEach(item => {
        if (item.id === this.formValidate.agreementNo) {
          modelId = item.modelId;
          if (item.maxAmount) this.maxAmount = item.maxAmount;
        }
      });
      if (modelId == "06") {
        // if (val.label == '随心托') {
        this.rentTermShow = false;
      } else {
        this.rentTermShow = true;
        this.cityList.forEach(item => {
          if (this.formValidate.agreementNo === item.id) {
            if (item.rentTerm) {
              this.formValidate.rentTerm = item.rentTerm;
              this.rentDisable = true;
            } else {
              this.rentDisable = false;
            }
          }
        });
      }
    },
    onFinish() {
      this.childShow = false;
    },
    // 查看框架协议详情
    goDetail() {
      this.currentChild = frameworkAgreeDetail;
      this.currentParams = this.formValidate.agreementNo;
      this.childShow = true;
    },
    // 所在区域
    onSelect(params) {
      this.formValidate.receiveArea = params;
    },
    // 交付方式
    onOrderMethod(val) {
      this.formValidate.deliveryMethod = val;
      if (val === "SELF_PICK") {
        this.formValidate.receiveArea = "";
        this.formValidate.receiveAddress = "";
      }
    },
    //标的物小类
    async onTargetType(params) {
      this.formValidate.targetType = params;
      if (this.formValidate.leaseeId && this.formValidate.targetType) {
        await this.agreementList();
        // this.formValidate.agreementNo = "";
      }
    },
    addLinkMan() {
      this.$refs["contactSelect"].openModal(this.formValidate.leaseeId);
    },
    // 选择联系人
    onSelectContact(params) {
      this.formValidate.receiveContactId = params.id;
      this.linkVal = params;
    },
    // 是否清洗
    onChangeCode(val) {
      this.formValidate.cleaningRequired = val;
    },
    // 预期交付时间
    expectDate(val) {
      this.formValidate.expectedDeliveryDate = val;
    },
    // 框架协议号
    async agreementList() {
      this.cityList = [];
      let data = {
        url:
          "CORE-CONTRACT/messageService/queryService/queryFrameRentListByCondition4Order",
        body: {
          memberId: this.formValidate.leaseeId,
          targetType: this.formValidate.targetType
        }
      };
      this.cityList = await this.invoke(data);
    },
    async submit() {
      let valid = await this.$refs["formValidates"].validate();
      if (!valid) return;

      let checkData = {
        url:
          "MID-OPERATE-LEASE/messageService/orderService/checkFrameMaxAmoutLimit",
        body: {
          agreementNo: this.formValidate.agreementNo,
          orderAmount: this.formValidate.orderAmount
        }
      };
      let rentInfo = await this.invoke(checkData);

      let urls =
        "http://MID-DATA-REPORT/messageService/reportService/queryDepositDiffs";
      let queryDepositDiffs = await this.invoke(urls, {
        frameRent: this.formValidate.agreementNo,
        applyAmount: this.formValidate.orderAmount
      });
      queryDepositDiffs = queryDepositDiffs || false;

      let modalTitle = "确认";
      let modalContent = "确定要新增租赁吗?";
      if (!rentInfo.valid) {
        modalTitle = "提示";
        modalContent = `框架最大数量限制为${rentInfo.maxAmount},已在租数为:${rentInfo.rentingAmount},\n是否继续起租?`;
      }
      if (queryDepositDiffs && queryDepositDiffs?.depositDiff > 0) {
        modalTitle = "提示";
        modalContent = `此客户押金缴纳不足，应缴 ${queryDepositDiffs.leaseeDepositAmount} 元，实缴 ${queryDepositDiffs.accountAmount} 元,\n是否继续起租?`;
      }

      if (
        !rentInfo.valid &&
        queryDepositDiffs &&
        queryDepositDiffs?.depositDiff > 0
      ) {
        modalTitle = "提示";
        modalContent = `框架最大数量限制为${rentInfo.maxAmount},已在租数为:${rentInfo.rentingAmount},\n
          此客户押金缴纳不足，应缴 ${queryDepositDiffs.leaseeDepositAmount} 元，实缴 ${queryDepositDiffs.accountAmount} 元,\n是否继续起租?`;
      }

      let data = {
        url: "MID-OPERATE-LEASE/messageService/orderService/newOrder",
        body: {
          order: this.formValidate,
          attachmentFileIds: this.attachmentFileIds
        }
      };
      this.$Modal.confirm({
        title: modalTitle,
        content: modalContent,
        onOk: () => {
          this.invoke(data).then(res => {
            if (res) {
              this.$Message.success("新增租赁成功！");
              this.reset();
            }
          });
        }
      });
    },
    goBack() {
      this.$router.push({
        path: "/user-center/lease/leaseList"
      });
      this.reset();
    },
    reset() {
      this.maxAmount = null;
      this.isBack = false;
      this.cityList = [];
      this.formValidate.leaseOrderComment = "";
      this.$refs["formValidates"].resetFields();
      this.formValidate.receiveContactId = "";
      this.$refs.upFile.$refs.uploadFile.clearFiles();
      this.attachmentFileIds = [];
      this.linkVal = {
        name: "",
        mobile: "",
        email: "",
        identityNo: ""
      };
    }
  }
};
</script>

<style lang="scss">
#leaseTransact {
  height: 100%;
  .btn {
    margin-top: 30px;
    text-align: center;
  }
}
</style>